import sexselect from './SexSelect.vue'
const SexSelect = {
	install: function(Vue) {
		Vue.component('SexSelect', sexselect)
	}
}
export default SexSelect
